type Props = {
	image: string;
	imageAlt: string;
	eyebrow: string;
	title: string;
	tagline: string;
	logo?: string;
};

export function AboutHero({
	image,
	imageAlt,
	eyebrow,
	title,
	tagline,
	logo,
}: Props) {
	return (
		<div className="relative h-[400px] overflow-hidden bg-[var(--surface-inverted)] md:h-[520px]">
			<img
				src={image}
				alt={imageAlt}
				className="absolute inset-0 h-full w-full object-cover"
				style={{ objectPosition: "50% 26%" }}
			/>
			<div className="absolute inset-0 bg-[linear-gradient(to_top,rgb(10_10_9_/_0.92),rgb(10_10_9_/_0.3)_55%,rgb(10_10_9_/_0.1))]" />
			<div className="absolute inset-x-0 bottom-0 mx-auto flex max-w-[1360px] flex-col gap-3 px-6 pb-10 md:px-10 md:pb-12">
				<div className="flex items-center gap-2.5">
					{logo && (
						<img
							src={logo}
							alt=""
							className="h-7 w-7 rounded-[var(--radius-pill)] object-cover"
						/>
					)}
					<span className="text-[11px] font-bold uppercase tracking-[0.08em] text-[rgb(255_255_255_/_0.8)]">
						{eyebrow}
					</span>
				</div>
				<h1
					className="m-0 text-[31px] font-extrabold leading-[1.04] tracking-[-0.03em] text-white md:text-[64px] md:tracking-[-0.035em]"
					style={{ fontFamily: "var(--font-display)" }}
				>
					{title}
				</h1>
				<p className="m-0 max-w-[52ch] text-[14px] leading-[1.5] text-[rgb(255_255_255_/_0.82)] md:text-[19px]">
					{tagline}
				</p>
			</div>
		</div>
	);
}
